import { ADD_NOTIFICATION } from './actionTypes';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return Object.assign({}, state, action.payload.notification);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/notification/reducer.js